import "@styles/react/pages/page-authentication.scss";
import { Form } from "reactstrap";
import { Link } from "react-router-dom";
import ImageWrapper from "@src/@core/components/ui-components/image-wrapper";
import themeConfig from "@src/configs/theme-config";
import PasswordField from "@src/@core/components/fields/password-field";
import LoadingButton from "@components/ui-components/loading-button";
import InputField from "@src/@core/components/fields/input-field";
import useSuperadminLogin from "./use-superadmin-login";
import Flex from "@src/@core/components/ui-components/flex";
import Card from "@src/@core/components/ui-components/card";

const SuperadminLogin = () => {
    const { onSubmit, errors, control, loading, handleKeyPress } =
    useSuperadminLogin();

    const {
        app: { logo, name }
    } = themeConfig;

    return (
        <div className="auth-wrapper auth-basic px-2">
            <div className="auth-inner my-2">
                <Card containerClass="mb-0 p-1">
                    <Flex column justify="center" align="center">
                        <Link
                            className="brand-logo"
                            to="/"
                            onClick={(e) => e.preventDefault()}>
                            <ImageWrapper
                                src={logo}
                                rawImg
                                id="brand-logo"
                                alt="logo"
                                className="w-75 m-auto"/>
                            <div className="profile-cap superadmin" />
                        </Link>

                        <div className="text-center">
                            <h2 className="brand-text text-primary">Superadmin Panel</h2>
                            <h4 className="card-title mb-75">Welcome to {name}! 👋</h4>
                        </div>
                    </Flex>

                    <Form
                        data-cy="login-form"
                        className="mt-2"
                        onKeyDown={handleKeyPress}>
                        {/* Email Field */}
                        <InputField
                            id="email"
                            name="email"
                            label="Email"
                            errors={errors}
                            control={control}/>

                        {/* Password Field */}
                        <PasswordField
                            id="password"
                            name="password"
                            label="Password"
                            errors={errors}
                            control={control}/>

                        <LoadingButton
                            loading={loading}
                            testId="login"
                            onClick={onSubmit}
                            icon="login"
                            text="LOG IN"
                            className="my-2 w-100"/>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default SuperadminLogin;
